import React, {useState} from 'react';
import mime from 'mime-types';
import moment from 'moment';
import classnames from 'classnames';
import FileIcon from './FileIcon';
import Thumbnail from '../../../Thumbnail';
import AnimatedUploadingFilePopUp from '../../../AnimatedUploadingFilePopUp';
import showIcon from '../../../../assets/more_414141.svg';
import {errors as E} from '../../../../constants/errors';
import styles from './styles.module.scss';

const FileBlock = ({
                     fileID,
                     fileName,
                     uploadTime,
                     fileExtension,
                     thumbnail,
                     shumaID,
                     orderID,
                     stepID,
                     closeModal,
                     getStepData,
                     showGlobalErrorMessage,
                     handleSubmit,
                     getFileFromOrder,
                     copyFile,
                     fileTypeID,
                     getFileList
                   }) => {
  const [loading, setLoading] = useState(false);
  const [showInfo, setShowInfo] = useState(false);
  const handleShowInfo = () => setShowInfo(prevState => !prevState);
  const date = uploadTime ? moment.utc(uploadTime).format('DD-MM-YYYY') : '';

  const getType = () => {
    switch (mime.lookup(fileExtension)) {
      case 'application/pdf':
        return 'pdf';
      case 'image/gif':
      case 'image/jpeg':
      case 'image/jpg':
      case 'image/tiff':
      case 'image/png':
        return 'image';
      default:
        return null;
    }
  };

  const updateFile = async () => {
    try {
      const body = await getFileFromOrder({orderID, fileID});
      const mimeType = mime.lookup(fileExtension);
      return `data:${mimeType};base64,${body}`;
    } catch (e) {
      console.error(e)
    }
  };

  const handleOpen = () => {
    if (getType()) {
      Promise.resolve()
        .then(updateFile)
        .then((content) => {
          if (content) {
            let file = getType() === 'image'
              ? '<img src="' + content + '">'
              : '<iframe width="100%" height="100%" src="' + content + '"></iframe>'
            let popup = window.open();
            popup.document.write(file);
          } else {
            showGlobalErrorMessage(E.FILE_NOT_FOUND)
          }
        })
        .catch((e) => {
          console.error(e);
        })
    }
  };

  const handleCopyFile = () => {
    Promise.resolve()
      .then(() => setLoading(true))
      .then(() => {
        if (fileTypeID) {
          return copyFile(shumaID, fileID, fileTypeID);
        } else {
          return copyFile(shumaID, fileID);
        }
      })
      .then(() => handleSubmit())
      .catch(err => showGlobalErrorMessage(err.message))
      .then(() => setLoading(false))
      .then(() => {
        getStepData({shumaId: shumaID, stepId: stepID});
        getFileList({shumaId: shumaID})
      })
      .then(() => closeModal());
  };

  return (
    <>
      <div className={classnames(styles.fileBlockContainer)}>
        <img src={showIcon} className={styles.buttonShow} alt="show" onClick={handleShowInfo}/>
        <div className={styles.imageContainer} onClick={handleOpen}>
          {thumbnail
            ? <Thumbnail uri={thumbnail} fileExtension={fileExtension}/>
            : <FileIcon fileExtension={fileExtension}/>
          }
        </div>
        <div className={styles.infoContainer}>
          {showInfo && (
            <>
              <div className={styles.fileInfo}>
                <div className={styles.fileName}>{fileName}</div>
                <div className={styles.fileUploadDate}>
                  <div>{date}</div>
                </div>
              </div>
              <div onClick={handleCopyFile} className={styles.buttonCopy}>בחר</div>
            </>
          )}
        </div>
      </div>
      <AnimatedUploadingFilePopUp show={loading}/>
    </>
  );
};

export default FileBlock;
